<template>
  <div class="calc-desenquadramento-mei">
    <h2>Calculadora desenquadramento MEI</h2>
    <p>Preencha as informações abaixo e descubra a melhor opção para sua empresa.</p>

    <div
    id="loading"
    :class="{'loading--show': loading}"
    class="loading"
    >
      <span class="spinner" />
      <h3>Aguarde</h3>
      <p>Calculando...</p>
    </div>

    <div class="form" v-show="!loading">

      <div class="row-v">
        <div class="col-v">
          <label>
            <strong>Ramo de atividade da sua empresa</strong>
            <Dropdown
              :external-select="selectAtividade"
              :selected-item="atividade"
              placeholder="Selecione uma das opções"
            />
          </label>
        </div>

        <div class="col-v">
          <label for="faturamento">
              <strong>
                Mês/ano de abertura do seu MEI
              </strong>
            <InputData
              v-model.lazy="dataAbertura"
              :valid="validacoes.dataAbertura"
              :error="(toFloatNumber(dataAbertura) > 0 && !validacoes.dataAbertura)"
              @input="validacoes.dataAbertura = validators.data.valid(dataAbertura), 
              resetBilling = validators.data.resetBilling"
            />
          </label>
        </div>

      </div>
      <div class="row-v">
        <div class="col-v">
          <label>
            <div class="title-tooltip">
              <strong>{{ `Faturamento acumulado em ${previousYear}` }}</strong>
            </div>
            <InputFaturamento
            v-model.lazy="acumuladoAnoAnterior"
            :valid="validacoes.acumuladoAnoAnterior"
            :error="(toFloatNumber(acumuladoAnoAnterior) && !validacoes.acumuladoAnoAnterior)"
            @input="validacoes.acumuladoAnoAnterior = validators.recebeMensalmente.valid(acumuladoAnoAnterior, 0)"
            :resetToZero="resetBilling"
          />
          </label>
        </div>

        <div class="col-v">
          <label for="faturamento">
              <div class="title-tooltip">
                <strong>
                  {{ `Faturamento acumulado em ${currentYear}` }}

                  <TooltipText
                  :text="`Soma do faturamento acumulado em ${currentYear} até a data de realização dessa simulação.`"
                  :class-name="'marginl-40'"
                  class="tooltip"
                  style="margin-bottom:-2px"
                />
                </strong>

              </div>

            <InputFaturamento
              v-model.lazy="acumuladoAnoAtual"
              :valid="validacoes.acumuladoAnoAtual"
              :error="(toFloatNumber(acumuladoAnoAtual) && !validacoes.acumuladoAnoAtual)"
              @input="validacoes.acumuladoAnoAtual = validators.recebeMensalmente.valid(acumuladoAnoAtual, 0)"
            />
          </label>
        </div>

      </div>

      <ButtomPrimary
        :disabled="disableContinue"
        :texto="'Ver resultado'"
        class="actions__continue"
        :deepClass="'blue-light'"
        @click="onClickContinue"
      />

    </div>
  </div>
</template>
<script>

import { VMoney } from 'v-money';

import InputFaturamento from '@/components/Inputs/InputFaturamento.vue'
import InputData from '@/components/Inputs/InputData.vue'
import ButtomPrimary from '@/components/ButtomPrimary'
import TooltipText from '@/components/TooltipText'
import Dropdown from '@/components/DropDown'

import ValidationRules from '@/assets/js/util/validationRules'
import ValidatorSalary from '@/assets/js/util/validationRules/Salary';
import ValidatorData from '@/assets/js/util/validationRules/DateFunction';

import CalculatorDesenquadramentoMei from '@/assets/js/services/CalculatorDesenquadramentoMei.js';

export default {
  components: {
    Dropdown,
    InputData,
    InputFaturamento,
    ButtomPrimary,
    TooltipText
  },
  directives: {
    money: VMoney
  },
  data() {
    return {
      atividade: '',
      acumuladoAnoAnterior: '',
      acumuladoAnoAtual: '',
      dataAbertura:'',
      defaultValueCity: null,
      validationRules: new ValidationRules(),
      loading: false,
      locationValue: '',
      cidadeAtendida: '',
      resetBilling: false,
      validacoes: {
        atividade: false,
        validate: false,
        acumuladoAnoAnterior: false,
        acumuladoAnoAtual: false,
        dataAbertura: false,
        cidade: false,
        readyCidade: false,
      },
      validators: {
        recebeMensalmente: new ValidatorSalary(),
        data: new ValidatorData()
      },
    }
  },
  props: {
    pageExperts: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    isProd() {
      return ['www.contabilizei.com.br', 'blog.contabilizei.com.br'].includes(window.location.hostname);
    },
    selectAtividade(key) {
      this.atividade = key
      this.validacoes.atividade = key !== ''
    },
    validarCidade(cidade) {
      this.validacoes.cidade = (cidade.trim().length >= 3)
      this.validacoes.readyCidade = true;
    },
    normalizeText(text) {
      return (text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    },
    isCidadeAtendida(cidade) {
      return cidadesAtendidas.some((cidadeAtend) => {
        if (this.pageExperts) {
          const cityUf = `${this.normalizeText(cidadeAtend.cidade)} - ${this.normalizeText(cidadeAtend.uf)}`;
          return cityUf === this.normalizeText(cidade);
        }

        return this.normalizeText(cidadeAtend.cidade) === this.normalizeText(cidade);
      });
    },
    formatCidade(cidade) {
      return cidade.normalize('NFD').replace(/ /g, '').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    },
    selectCidade(cidade) {
      const cidadeEscolhida = cidadesAtendidas.some((cidadeAtend) => {
        return this.formatCidade(cidadeAtend.cidade) === this.formatCidade(cidade)
      })

      this.validacoes.cidade = cidadeEscolhida
      this.cidade = cidade
    },

    toFloatNumber(value) {
      if (!value) {
        return null;
      }
      return this.validators.recebeMensalmente.getFloatNumber(value);
    },
    isValidStepFinal() {
      return (
        this.validacoes.atividade
        && this.validacoes.acumuladoAnoAnterior
        && this.validacoes.acumuladoAnoAtual
        && this.validacoes.dataAbertura

      )
    },
    numberToSend(value) {
      const newvalue = value
        .replace('R$', '')
        .replace(' ', '')
        .replace(',00', '')
        .replace('.', '')
        .replace(',', '.')

      return +newvalue
    },

    onClickContinue() {
      this.loading = true;
      CalculatorDesenquadramentoMei
      .calculate(
        this.atividade,
        this.numberToSend(this.acumuladoAnoAnterior),
        this.numberToSend(this.acumuladoAnoAtual),
        this.dataAbertura
        ).then((result) => {
        this.$emit('onResults', result)
      }).catch(() => {
        this.$emit('onError', true)
      })
      .finally(()=> {
        this.loading = false;
        dataLayer.push({
          event: 'customEvent',
          eventCategory: `site:calculadora-desenquadramento-mei`,
          eventAction: 'click:calculadora',
          eventLabel: `ver-resultado`
        })
      })
    },
  },
  computed: {
    disableContinue() {
      return !this.isValidStepFinal();
    },
    previousYear() {
      const currentDate = new Date();
      const baseYear = currentDate.getFullYear();
      return currentDate.getMonth() === 0 ? baseYear - 2 : baseYear - 1;
    },
    currentYear() {
      return this.previousYear + 1;
    },
  },

}

</script>
<style lang="scss" src="./CalculatorForm.styles.scss" scoped></style>
